module.exports = __webpack_public_path__ + "img/20180815_151629_181.a3d1ed66.jpg";